import React from "react";
import clsx from "clsx";
import {WARNING_COLOR} from "../../../themes/themeConfigurator";
import WarningTooltip from "../../WarningTooltip";

const WarningIcon = props => {
  return <i className={clsx('fal fa-exclamation-circle', props.className)} style={{color: WARNING_COLOR}} />
};

export default WarningIcon;

export const MissingRequiredIcon = props => (
  <WarningTooltip
    title={'Bitte befüllen Sie die fehlenden Pflichtfelder.'}
    icon={<WarningIcon {...props} />}
  />
)